export const INTERCOM_TARGET_PREFIX = 'updateAction';
